(function () {
  let metafieldData;
  let excludeColumn = null;

  // 排除数值转换
  const exclude_title = ['NUMERISCHE GRÖSSE', 'NUMERIC SIZE']
  function changeUnit(row, column, value, unit = "inch") {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const d = 2.54;
    const re1 = new RegExp(/^(\d+(\.\d+)?)-(\d+(\.\d+)?)$/);
    if ((type == "body" && row != 1) || (type == "product" && row != 1)) {
      // 排除 NUMERIC SIZE 的数值转换
      if (exclude_title.find((title) => {
        return value.includes(title)
      })) excludeColumn = row;
      if (row && row === excludeColumn) return value;

      if (/^(\d+)(\.\d+)?$/.test(value) && unit != "cm") {
        value = value == 0 ? "0" : change(value);
      } else if (value == "" || value == null) {
        value = "&nbsp;";
      } else if (re1.test(value) && unit != "cm") {
        const res = re1.exec(value);
        value = `${change(res[1])}-${change(res[3])}`;
      }
    }

    function change(v) {
      return Math.round(v / d);
      // return Math.ceil(v / d)
    }

    return value;
  }
  function init() {
    metafieldData = JSON.parse($(".pr_metafield_json").html() || {});
    const sizing_type = metafieldData["sizing_type"]?.length || 0;
    lengthStylesDesc = sizing_type > 0 ? `<div class="sizing_type_desc">
      <div class="item"><div class="title">Petite</div><div>${window.length_styles_desc["petite"]}</div></div>
      <div class="item"><div class="title">Regular</div><div>${window.length_styles_desc["regular"]}</div></div>
      <div class="item"><div class="title">Tall</div><div>${window.length_styles_desc["tall"]}</div></div>
    </div>` : '';
    const product_type = meta.product.type
    const video_map = window.size_guide_video_map[product_type]
    function makeVideoCover() {
      // 商品类型
      // 如果没有找到映射，返回空字符串
      if (!video_map) return ""
      console.log('video_map', video_map)
      // 返回视频封面HTML
      return `
      <a data-open-mfp-video data-class="size_guide_video" style="cursor: pointer; margin-bottom: 10px;" id="size_guide_video-cover" data-options='{"type": "html5", "autoplay": true, "loop": true, "preload": "auto", "src":"${video_map.video}"}'>
      <img class="video_cover lazyloadt4s t4s-lz--fadeIn t4s-d-none t4s-d-md-block" data-src="${video_map.cover?.pc}" alt="Size Guide Video Cover" />
      <img class="video_cover lazyloadt4s t4s-lz--fadeIn t4s-d-block t4s-d-md-none" data-src="${video_map.cover?.m}" alt="Size Guide Video Cover" />
      </a>`
    }

    const html = `
      <h1>Size Guide</h1>
      <div class="guide-entry">
        <img class="icon" src="https://oglmove.com/cdn/shop/t/60/assets/ruler.svg?v=77864277191025910731726841521" width="24" height="24"/>
        <a id="what-my-size-entry" onclick="showModal('Size Guide')" class="t4s-ch title" style="cursor: pointer">What's My Size?</a>
      </div>
      <div class="guide_table">
        <div class="header">
          <span class="body hit" type="body">Body Measurements</span>
          <span class="country" type="country">Country / Region</span>
        </div>
        ${lengthStylesDesc}
        <div class="switch" unit="cm">
          <h3>Switch to</h3>
          <span class="wrap">
            <span class="name inch">IN</span>
            <span class="name cm hit">CM</span>
          </span>
        </div>
        <div class="content">
          <div class="fixed_header"></div>
          <div class="data"></div>
        </div>
      </div>
      <div class="tips">
        <span class='size'>
          <p>${metafieldData["size_guide_model_data"] || ""}</p>
          <p>* This data is suitable for the majority of body types. If your bust size is DD cup, please be cautious when purchasing the brami style.</p>
        </span>
        <span class='others'>* This data was obtained from manually measuring the product, it may be off by 1-2 CM.</span>
      </div>

      <div class="info body" style="flex-direction: column;">
        <h2 style="margin-bottom: 10px; text-align: center;">How to Measure your Body?</h2>
        ${makeVideoCover()}
        <div style="display: flex;">
          <div class="text">
          <h3><span class="num">1</span>Your bust</h3>
          <p>Measure the circumference over the fullest part of your bust.</p>
          <h3><span class="num">2</span>Your waist</h3>
          <p>Measure your waist at the thinnest place.</p>
          <h3><span class="num">3</span>Your hips</h3>
          <p>Measure the fullest part of your hips.</p>      
          </div>
          <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_4d0d979f-d438-4ad8-8694-50b80df94b79.png?v=1692281145"></div>
        </div>
      </div>

      <div class="info tops">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Shoulder</h3>
          <p>Measure from where the shoulder seam meets the sleeve on one side to another side.</p>
          <h3><span class="num">2</span>Bust</h3>
          <p>Measure from the stitches below the armpits on one side to another. Double the measurement for the full bust circumference.</p>
          <h3><span class="num">3</span>Length</h3>
          <p>Measure from where the shoulder seam meets the collar to the hem.</p>
          <h3><span class="num">4</span>Sleeves</h3>
          <p>Measure from where the shoulder seam meets armhole to the cuff.</p>
          <h3><span class="num">5</span>Bicep</h3>
          <p>Measure around the fullest part of the upper arm</p>
          <h3><span class="num">6</span>Cuff</h3>
          <p>Measure the distance from the end of the cuff to the point where the cuff attaches to the sleeve.</p>
          <h3><span class="num">7</span>Hem</h3>
          <p>Measure all the way around the hemline.</p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/top_15d3f5fc-6d3b-48a0-bbb8-034e44217d88.png?v=1692281146"></div>
      </div>

      <div class="info dresses">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Shoulder</h3>
          <p>Measure from where the shoulder seam meets the sleeve on one side to another side.</p>
          <h3><span class="num">2</span>Bust</h3>
          <p>Measure from the stitches below the armpits on one side to another. Double the measurement for the full bust circumference.</p>
          <h3><span class="num">3</span>Bicep</h3>
          <p>Measure around the fullest part of the upper arm.</p>
          <h3><span class="num">4</span>Hem</h3>
          <p>Measure all the way around the hemline.</p>
          <h3><span class="num">5</span>Length</h3>
          <p>Measure from where the shoulder seam meets the collar to the hem.</p>
          <h3><span class="num">6</span>Sleeves</h3>
          <p>Measure from where the shoulder seam meets armhole to the cuff.</p>
          <h3><span class="num">7</span>Cuff</h3>
          <p>Measure the distance from the end of the cuff to the point where the cuff attaches to the sleeve.</p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/dress_6473fd21-7512-4a10-b23c-f609b865f7f5.png?v=1692281146"></div>
      </div>

      <div class="info bottoms">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Waist</h3>
          <p>Measure straight across the top of the waistband from edge to edge. Double the measurement for the full waist circumference.</p>
          <h3><span class="num">2</span>Hip</h3>
          <p>Measure straight across the widest hip line from edge to edge.Double the measurement for the full hip circumference.</p>
          <h3><span class="num">3</span>Thigh</h3>
          <p>Measure across straight from the crotch seam to the outside of the leg.Double the measurement for the full thigh circumference.</p>
          <h3><span class="num">4</span>Length</h3>
          <p>Measure from the top of the waistband to the hemline.</p>
          <h3><span class="num">5</span>Inseam</h3>
          <p>Measure straight down the inside leg from the crotch to the hem. </p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/bottom_23e0c41d-307c-4fac-90f1-611f4f918579.png?v=1692281145"></div>
      </div>

      <div class="info skirts">
        <div class="text">
          <h2>How to Measure the Product's Size?</h2>
          <h3><span class="num">1</span>Waist</h3>
          <p>Measure straight across the top of the waistband from edge to edge. Double the measurement for the full waist circumference.</p>
          <h3><span class="num">2</span>Hip</h3>
          <p>Measure straight across the widest hip line from edge to edge.Double the measurement for the full hip circumference.</p>
          <h3><span class="num">3</span>Length</h3>
          <p>Measure from the top of the waistband to the hemline.</p>
          <h3><span class="num">4</span>Hem</h3>
          <p>Measure all the way around the hemline.</p>
        </div>
        <div class="guide_image"><img src="https://cdn.shopify.com/s/files/1/0506/5284/0124/files/skri_f89f4af5-9fe9-430a-87ae-df3b48a62fbd.png?v=1692281145"></div>
      </div>
      `;
    $(".mibao_size_guide_2022").html(html);

    if (!metafieldData["sizedata"]) {
      // sizeData没数据
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(
        ".mibao_size_guide_2022 .guide_table .header span[type=product]"
      ).addClass("hit");
      $(".mibao_size_guide_2022 .guide_table .header span[type=body").hide();
    }
    $("#size_guide_video-popup").hide(0);

    makeTable();
    makeInfo();

    $(".mibao_size_guide_2022 .guide_table .switch").click(function (e) {
      const unit = $(this).attr("unit");
      const newUnit = unit == "cm" ? "inch" : "cm";
      $(this).attr("unit", newUnit);
      $(this).find(".name").removeClass("hit");
      $(this).find(`.name.${newUnit}`).addClass("hit");
      makeTable();
    });
    $(".mibao_size_guide_2022 .guide_table .header span").click(function (e) {
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(this).addClass("hit");
      makeInfo();
      makeTable();
    });
    $(".mibao_size_guide_2022 #size_guide_video-cover").click(function (e) {
      e.preventDefault();
      console.log('click video cover')
      // 返回视频封面HTML
      // $("#size_guide_video-popup .size_guide_video video")[0].currentTime = 0;
      $("#size_guide_video-popup .size_guide_video video")[0].play();
      $("#size_guide_video-popup").show(0);
    })
    $("#size_guide_video-popup .t4s-video-popup-wrapper").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('click wrapper')
      $("#size_guide_video-popup").hide(0);
    })
    $("#size_guide_video-close").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $("#size_guide_video-popup .size_guide_video video")[0].currentTime = 0;
      $("#size_guide_video-popup .size_guide_video video")[0].pause();
      $("#size_guide_video-popup").hide(0);
    })
  }
  function makeInfo() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const product_types = meta.product.type.split(">");
    let info_type;
    if (type == "product") {
      // 上衣tops，连衣裙dress，裤装pants,shorts，半裙skirts，skorts
      if (/tops/i.test(product_types[1])) {
        info_type = "tops";
      } else if (/dresses/i.test(product_types[1])) {
        info_type = "dresses";
      } else if (
        /bottoms/i.test(product_types[1]) &&
        !/skirt/i.test(product_types[2])
      ) {
        info_type = "bottoms";
      } else if (/skirt/i.test(product_types[2])) {
        info_type = "skirts";
      }
    } else if (type == "body") {
      info_type = "body";
    }
    $(".mibao_size_guide_2022 .info").hide();
    if (info_type) {
      $(`.mibao_size_guide_2022 .info.${info_type}`).show();
    }
  }
  function makeTable() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const unit = $(".mibao_size_guide_2022 .guide_table .switch").attr("unit");
    $(".mibao_size_guide_2022 .guide_table .switch").show(0);
    $(".mibao_size_guide_2022 .tips").show(0);
    let sizeData = [];
    let needResize = true;
    if (type == "product" && metafieldData["sizedata"]) {
      const productSizeDataOrigin = metafieldData["sizedata"];
      sizeData = productSizeDataOrigin
        .split("\n")
        .filter((o) => o)
        .map((o, r) => o.split("|").map((v, c) => changeUnit(r, c, v, unit)));
      sizeData[0][0] = "&nbsp;";
    } else if (type == "body") {
      sizeData = window.ogl_size_guide_body.map((o, r) => o.map((v, c) => changeUnit(r, c, v, unit)));
    } else if (type == "size") {
      sizeData = [
        [
          "<span class='w'>weight<br><sub>(LBS)</sub></span><span class='h'>height</span><b>&nbsp<b>",
          "<100",
          "100",
          "120",
          "130",
          "140",
          "150",
          "160",
          "170",
          "180",
          "190",
          "200",
        ],
        ["5'1''", "XS", "S", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'2''", "XS", "XS", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'3''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'4''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'5''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'6''", "XS", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'7''", "", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'8''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'9''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'10''", "", "", "S", "S", "M", "M", "M", "L", "L", "L", "XL"],
        ["5'11''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
        ["6'0''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
      ];
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
    } else if (type == "country") {
      sizeData = [
        ["&nbsp;", "US", "EU", "AUS", "UK", "CAN"],
        ["XS", "0", "30-32", "4", "4", "0"],
        ["S", "2-4", "34-36", "6-8", "6-8", "2-4"],
        ["M", "6-8", "38-40", "10-12", "10-12", "6-8"],
        ["L", "10-12", "42-44", "14-16", "14-16", "10-12"],
        ["XL", "14-16", "46-48", "18-20", "18-20", "14-16"],
        ["2XL", "18", "50-52", "22", "22", "18"],
      ];
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
      $(".mibao_size_guide_2022 .tips").hide(0);
    }
    let tableHtml = "";
    let tableFieldNameHtml = "";
    if (needResize) {
      // 数据转换，行列对调
      const sizeDataResize = [];
      for (let index in sizeData) {
        const item = sizeData[index];
        for (let key in item) {
          if (sizeDataResize[key] == undefined) {
            sizeDataResize[key] = [];
          }
          sizeDataResize[key][index] = item[key];
        }
      }
      sizeData = sizeDataResize;
    }

    // console.log(sizeDataResize)

    // for(let item of sizeData){
    for (let item of sizeData) {
      let tmp = `<tr><td>${item.slice(1).join("</td><td>")}</td></tr>`;
      let tmp2 = `<tr><td>${item[0]}</td></tr>`;
      tableHtml += tmp;
      tableFieldNameHtml += tmp2;
    }
    tableHtml = `<table>${tableHtml}</table>`;
    tableFieldNameHtml = `<table>${tableFieldNameHtml}</table>`;
    $(".mibao_size_guide_2022 .guide_table .content .data").html(tableHtml);
    $(".mibao_size_guide_2022 .guide_table .content .fixed_header").html(
      tableFieldNameHtml
    );
    // console.log(unit, sizeDataString, sizeData, tableHtml)

    $(".mibao_size_guide_2022 .tips span").hide();
    if (type == "size") {
      $(
        ".mibao_size_guide_2022 .guide_table .content .fixed_header table"
      ).addClass("size");
      $(".mibao_size_guide_2022 .guide_table .content .data table").addClass(
        "size"
      );
      $(".mibao_size_guide_2022 .guide_table .content .data td").each(
        function () {
          const val = $(this).text();
          if (["XS", "S", "M", "L", "XL", "XXL"].indexOf(val) > -1) {
            $(this).addClass(`size_color_${val.toLowerCase()}`);
          }
        }
      );
      $(".mibao_size_guide_2022 .tips span.size").show();
    } else {
      $(".mibao_size_guide_2022 .tips span.others").show();
    }
  }
  MB_jsDeferHandle(init, ["jQuery"]);
})();
